import React from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';

function MediaImagePreviewModal({ show, onClose, item }) {
    if (!item) {
        return null;
    }

    return (
        <Modal
            show={show}
            onHide={onClose}
            centered
            dialogClassName="my-files-preview-modal"
            contentClassName="my-files-preview-modal__content"
        >
            <Modal.Header className="my-files-preview-modal__header border-0 d-flex align-items-center">
                <div className="d-flex align-items-center gap-3 min-width-0 flex-grow-1">
                    <span className="my-files-preview-modal__icon-badge flex-shrink-0">
                        <i className="bi bi-image"></i>
                    </span>
                    <div className="min-width-0">
                        <Modal.Title className="h5 mb-0 fw-semibold text-truncate">{item.name}</Modal.Title>
                        <div className="small text-muted text-truncate">{item.path}</div>
                    </div>
                </div>
                <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary rounded-pill ecx-modal__close-btn ms-auto flex-shrink-0"
                    onClick={onClose}
                    aria-label="Close"
                >
                    <i className="bi bi-x-lg"></i>
                </button>
            </Modal.Header>

            <Modal.Body className="my-files-preview-modal__body">
                <img src={item.path} alt={item.name} className="my-files-preview-modal__image" />
            </Modal.Body>

            <Modal.Footer className="my-files-preview-modal__footer border-0">
                <a
                    href={item.path}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-sm btn-outline-secondary"
                >
                    <i className="bi bi-box-arrow-up-right me-1"></i>
                    Open in new tab
                </a>
                <button type="button" className="btn btn-sm btn-outline-secondary rounded-pill ecx-modal__footer-close-btn" onClick={onClose}>
                    <i className="bi bi-x-circle me-1"></i>
                    Close
                </button>
            </Modal.Footer>
        </Modal>
    );
}

MediaImagePreviewModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    item: PropTypes.shape({
        name: PropTypes.string,
        path: PropTypes.string,
    }),
};

export default MediaImagePreviewModal;
